import { Component, Input } from '@angular/core';

@Component({
  selector: 'idp-skip-content',
  templateUrl: './skip-content.component.html',
  styleUrls: ['./skip-content.component.scss']
})
export class SkipContentComponent {
  @Input() label = '';
}
